// --- UNIFIED CATEGORY STRUCTURE ---
// Works for both Radio and Podcasts.
export const CATEGORY_GROUPS = [
  {
    label: "Niche & Interests",
    options: [
      {
        label: "Outdoor & Fishing",
        value: "fishing_outdoor",
        icon: "fa-fish-fins",
      },
      { label: "Tech & AI", value: "tech_ai_software", icon: "fa-microchip" },
      {
        label: "History & Science",
        value: "history_science",
        icon: "fa-flask",
      },
      {
        label: "Economy & Business",
        value: "economy_business",
        icon: "fa-briefcase",
      },
      {
        label: "Food & Cooking",
        value: "cooking_food_wine",
        icon: "fa-utensils",
      },
    ],
  },
  {
    label: "Vibe & Mood",
    options: [
      { label: "Focus & Study", value: "lofi", icon: "fa-mug-hot" },
      { label: "Chill & Lounge", value: "chill", icon: "fa-couch" },
      { label: "Dark & Noir", value: "dark", icon: "fa-moon" },
      { label: "High Energy", value: "workout", icon: "fa-bolt" },
    ],
  },
  {
    label: "Music Culture",
    options: [
      { label: "Rock & Indie", value: "rock_indie", icon: "fa-guitar" },
      { label: "Electronic & Synth", value: "electronic", icon: "fa-robot" },
      { label: "Jazz & Soul", value: "jazz_soul", icon: "fa-saxophone" },
      { label: "Retro (80s/90s)", value: "retro", icon: "fa-compact-disc" },
      { label: "Classical", value: "classical", icon: "fa-violin" },
    ],
  },
  {
    label: "Information & Sports",
    options: [
      { label: "News & World", value: "news", icon: "fa-newspaper" },
      { label: "Sports", value: "sports", icon: "fa-futbol" },
      { label: "Comedy", value: "comedy", icon: "fa-face-laugh-squint" },
    ],
  },
];

// Backward compatibility for UI components expecting these names
export const RADIO_GROUPS = CATEGORY_GROUPS;
export const POD_GROUPS = [CATEGORY_GROUPS[0]]; // Pods focus on the Niche group primarily
export const CURATOR_GROUPS = [CATEGORY_GROUPS[1]]; // Curator focuses on Vibe

// --- TAG MAPPING ---
// Maps raw API tags (from Radio Browser or RSS) to our internal category values.
export const THEME_MAPPINGS: Record<string, string> = {
  // Niche: Outdoor & Fishing
  fishing: "fishing_outdoor",
  hunting: "fishing_outdoor",
  outdoor: "fishing_outdoor",
  nature: "fishing_outdoor",
  wildlife: "fishing_outdoor",
  camping: "fishing_outdoor",

  // Niche: Tech & AI
  tech: "tech_ai_software",
  technology: "tech_ai_software",
  ai: "tech_ai_software",
  software: "tech_ai_software",
  coding: "tech_ai_software",
  startup: "tech_ai_software",
  science: "history_science",
  history: "history_science",
  space: "history_science",

  // Niche: Economy
  business: "economy_business",
  economy: "economy_business",
  finance: "economy_business",
  crypto: "economy_business",
  investing: "economy_business",
  marketing: "economy_business",

  // Niche: Food
  food: "cooking_food_wine",
  cooking: "cooking_food_wine",
  wine: "cooking_food_wine",

  // Music: Rock & Indie
  rock: "rock_indie",
  indie: "rock_indie",
  alternative: "rock_indie",
  metal: "rock_indie",
  punk: "rock_indie",
  grunge: "rock_indie",

  // Music: Electronic
  electronic: "electronic",
  synth: "electronic",
  techno: "electronic",
  house: "electronic",
  dance: "electronic",
  edm: "electronic",

  // Music: Jazz & Soul
  jazz: "jazz_soul",
  soul: "jazz_soul",
  blues: "jazz_soul",
  funk: "jazz_soul",
  "r&b": "jazz_soul",

  // Moods
  lofi: "lofi",
  chill: "chill",
  lounge: "chill",
  ambient: "chill",
  study: "lofi",
  focus: "lofi",
  relax: "chill",
  sleep: "chill",
  workout: "workout",
  gym: "workout",
  running: "workout",

  // Decades
  "80s": "retro",
  "90s": "retro",
  oldies: "retro",
  "70s": "retro",
  disco: "retro",

  // Info
  news: "news",
  talk: "news",
  politics: "news",
  sports: "sports",
  football: "sports",
  soccer: "sports",
  comedy: "comedy",
  humor: "comedy",
};

// --- REVERSE MAPPING FOR API SEARCH ---
// Expands internal category IDs back to raw tags for RadioBrowser/APIs
export const TAG_EXPANSIONS: Record<string, string> = {
  fishing_outdoor: "fishing,outdoor,nature,hunting,camping",
  tech_ai_software: "tech,technology,software,coding,startup",
  history_science: "history,science,space,education",
  economy_business: "business,economy,finance,investing,crypto",
  cooking_food_wine: "food,cooking,wine,culinary,gastronomy",
  rock_indie: "rock,indie,alternative,metal,punk",
  electronic: "electronic,synth,techno,house,edm,dance",
  jazz_soul: "jazz,soul,blues,funk,r&b",
  retro: "80s,90s,70s,oldies,retro,disco",
  news: "news,politics,talk,world news",
  sports: "sports,football,soccer",
  comedy: "comedy,humor,entertainment",
  lofi: "lofi,study,focus,beats",
  chill: "chill,lounge,ambient,relax",
  workout: "workout,gym,fitness,running",
  dark: "dark,noir,ambient",
  classical: "classical,opera,baroque",
};

export const SURPRISE_GENRES = [
  "eurodance",
  "polka",
  "death metal",
  "gregorian",
  "j-pop",
  "bluegrass",
  "gabber",
  "salsa",
  "bossa nova",
  "afrobeat",
  "baroque",
  "dubstep",
  "vaporwave",
  "ska",
  "opera",
  "disco",
  "lofi",
  "soundtrack",
  "rockabilly",
  "underground",
  "pirate",
  "experimental",
  "ambient",
  "house",
  "jazz",
];

export const SORT_OPTIONS = [
  { value: "popular", label: "Popular" },
  { value: "trending", label: "Trending" },
  { value: "bitrate", label: "High Quality" },
  { value: "latest_episode", label: "Latest Episode" },
  { value: "name", label: "Name (A-Z)" },
];
